import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Sparkles, Heart } from 'lucide-react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  padding: ${props => props.theme.spacing['4xl']} 0;
  background-color: ${props => props.theme.colors.text.primary};
  color: rgba(255, 255, 255, 0.8);
`;

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 ${props => props.theme.spacing['2xl']};
`;

const ContentWrapper = styled.div`
  max-width: 64rem;
  margin: 0 auto;
  text-align: center;
`;

const Tagline = styled.p`
  font-size: ${props => props.theme.typography.fontSize.xl};
  font-weight: ${props => props.theme.typography.fontWeight.light};
  line-height: 1.7;
  margin-bottom: ${props => props.theme.spacing.lg};
  color: rgba(255, 255, 255, 0.9);
  
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    font-size: ${props => props.theme.typography.fontSize['2xl']};
  }
`;

const FinalMessage = styled.p`
  font-family: ${props => props.theme.typography.fontFamily.display};
  font-size: ${props => props.theme.typography.fontSize.lg};
  color: ${props => props.theme.colors.accent.gold};
  margin-bottom: 3rem;
`;

const Divider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${props => props.theme.spacing.lg};
  margin-bottom: ${props => props.theme.spacing['2xl']};
`;

const DividerLine = styled.div`
  height: 1px;
  width: 4rem;
  background: rgba(255, 255, 255, 0.2);
`;

const DividerIcon = styled(Sparkles)`
  width: 1.25rem;
  height: 1.25rem;
  color: ${props => props.theme.colors.accent.gold};
`;

const Brand = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${props => props.theme.spacing.sm};
  margin-bottom: ${props => props.theme.spacing.lg};
  
  svg {
    width: 1.25rem;
    height: 1.25rem;
    color: ${props => props.theme.colors.primary.main};
  }
  
  span {
    font-family: ${props => props.theme.typography.fontFamily.display};
    font-size: ${props => props.theme.typography.fontSize.lg};
    font-weight: ${props => props.theme.typography.fontWeight.semibold};
    color: white;
  }
`;

const Copyright = styled.p`
  font-size: ${props => props.theme.typography.fontSize.sm};
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: ${props => props.theme.spacing.sm};
`;

const PoweredBy = styled.p`
  font-size: ${props => props.theme.typography.fontSize.sm};
  color: rgba(255, 255, 255, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${props => props.theme.spacing.xs};
  
  svg {
    width: 1rem;
    height: 1rem;
    color: ${props => props.theme.colors.destructive};
    fill: ${props => props.theme.colors.destructive};
  }
`;

const Footer = () => {
  const { t } = useLanguage();

  return (
    <FooterContainer>
      <Container>
        <ContentWrapper>
          <Tagline>{t('footer.tagline')}</Tagline>
          <FinalMessage>{t('footer.final')}</FinalMessage>

          <Divider>
            <DividerLine />
            <DividerIcon />
            <DividerLine />
          </Divider>

          <Brand>
            <Sparkles />
            <span>Blue Dreams</span>
          </Brand>

          <Copyright>{t('footer.copyright')}</Copyright>
          <PoweredBy>
            {t('footer.powered')} <Heart />
          </PoweredBy>
        </ContentWrapper>
      </Container>
    </FooterContainer>
  );
};

export default Footer;
